var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "8", md: "6" } },
            [
              _c("v-text-field", {
                attrs: { label: "New Role Name", clearable: "" },
                model: {
                  value: _vm.newRole,
                  callback: function($$v) {
                    _vm.newRole = $$v
                  },
                  expression: "newRole"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    disabled: _vm.isSaving || _vm.isLoading,
                    loading: _vm.isSaving,
                    color: "secondary",
                    dense: ""
                  },
                  on: { click: _vm.createRole }
                },
                [_vm._v("Add Role")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.roles,
                  "items-per-page": 15,
                  "single-expand": "",
                  "show-expand": "",
                  "item-key": "name",
                  expanded: _vm.expanded,
                  "footer-props": {
                    showFirstLastPage: true,
                    itemsPerPageOptions: [-1, 10, 15, 20, 25],
                    firstIcon: "mdi-arrow-collapse-left",
                    lastIcon: "mdi-arrow-collapse-right",
                    prevIcon: "mdi-minus",
                    nextIcon: "mdi-plus"
                  }
                },
                on: {
                  "update:expanded": function($event) {
                    _vm.expanded = $event
                  },
                  "item-expanded": _vm.setEditPermissions
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `expanded-item`,
                      fn: function({ headers, item }) {
                        return [
                          _c(
                            "td",
                            {
                              staticClass: "pa-1",
                              attrs: { colspan: headers.length }
                            },
                            [
                              _c(
                                "v-expansion-panels",
                                { attrs: { accordion: "" } },
                                _vm._l(_vm.entities, function(entity, i) {
                                  return _c(
                                    "v-expansion-panel",
                                    { key: `e-${i}` },
                                    [
                                      _c("v-expansion-panel-header", [
                                        _vm._v(_vm._s(entity))
                                      ]),
                                      _c(
                                        "v-expansion-panel-content",
                                        [
                                          _c(
                                            "v-container",
                                            [
                                              _c(
                                                "v-row",
                                                { attrs: { "no-gutters": "" } },
                                                _vm._l(
                                                  _vm.permissions,
                                                  function(permission, j) {
                                                    return _c(
                                                      "v-col",
                                                      {
                                                        key: `p-${j}`,
                                                        attrs: {
                                                          cols: "12",
                                                          md: "2"
                                                        }
                                                      },
                                                      [
                                                        _c("v-checkbox", {
                                                          staticClass:
                                                            "mt-0 text-body-2",
                                                          attrs: {
                                                            dense: "",
                                                            label: _vm.getLabel(
                                                              permission
                                                            ),
                                                            value: `${entity}.${permission}`
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.editPermissions,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.editPermissions = $$v
                                                            },
                                                            expression:
                                                              "editPermissions"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-center justify-md-end ma-2"
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "success" },
                                      on: {
                                        click: function($event) {
                                          return _vm.updatePermissions(
                                            item.name
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Save")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }